import React from 'react';
import { useTranslation } from 'react-i18next';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { useSectors, useCompanies } from '../../../hooks';
import AddIcon from '@mui/icons-material/Add';

const SektorsPage = () => {
  const { t } = useTranslation();

  return (
    <DynamicCrudPage
      entityType="sectors"
      hook={useSectors}
      additionalHooks={{
        companies: useCompanies,
      }}
      addButtonTextKey="table.actions.addSector"
      addButtonIcon={<AddIcon />}
      entityTypeForDataTable="sector"
    />
  );
};

export default SektorsPage;
